import { Richtext } from "storyblok-js-client";
import { IconNames } from "@tvg/design-system";
import { ButtonVariant } from "@tvg/design-system/src/components/button/types";
import { BetaFeatureDetail } from "@tvg/beta-program/src/containers/BetaFeaturesModal/types";
import { Whitelist } from ".";

export enum ActionType {
  CLOSE_SPLASH = "CLOSE_SPLASH_MODAL",
  OPEN_SPLASH = "OPEN_SPLASH_MODAL",
  CLOSE_FEATURES_PREVIEW = "CLOSE_FEATURES_PREVIEW_MODAL",
  OPEN_FEATURES_PREVIEW = "OPEN_FEATURES_PREVIEW_MODAL",
  SET_CONTENT = "SET_MESSAGE_CONTENT",
  SET_WHITELIST = "SET_USER_WHITELIST"
}

export interface State {
  splashModal: {
    isOpen: boolean;
  };
  featurePreviewModal: {
    isOpen: boolean;
  };
  content: CapiContent | {};
  whitelist: Whitelist[];
}

export interface Action {
  type: ActionType;
  payload: Record<string, unknown> | Whitelist[];
}

export enum PAGE_ACTION {
  CONFIRM = "confirm",
  CANCEL = "dismiss",
  LEARN_MORE = "learn",
  LATER = "later",
  START = "start"
}

export interface ModalAction {
  type?: PAGE_ACTION;
  text?: string;
  variant?: ButtonVariant;
}

export interface ModalDescription {
  title?: string;
  text?: Richtext;
}

export interface ModalDetailsList extends ModalDescription {
  icon?: IconNames;
}

export interface ModalDetails extends ModalDescription {
  list?: ModalDetailsList[];
}

export interface ModalDynamicContent<T> {
  content?: T;
  actions?: ModalAction[];
}

export interface ModalContent {
  title?: string;
  imageUrl?: string;
  description?: ModalDynamicContent<Richtext>;
  details?: ModalDynamicContent<BetaFeatureDetail>;
  welcomeMessage?: ModalDynamicContent<ModalDescription>;
}

export interface CapiContent {
  programPage?: ModalContent;
  myStable?: ModalContent;
}

export interface AlertMessagesContent {
  title?: string;
  description?: string;
}

export interface AlertMessages {
  exit?: AlertMessagesContent;
  dismiss?: AlertMessagesContent;
}
